import { usePage } from '@inertiajs/react';
import { Autocomplete, useLoadScript, Libraries } from '@react-google-maps/api';
import { useEffect, useRef } from 'react';
import { Input } from '@/components/ui/input';
import { Env } from '@/types/env';
const libraries: Libraries = ['places'];

const AddressAutocomplete = ({ address, setAddress, onSelect }:  {
    address: string;
    setAddress: (address: string) => void;
    onSelect: (place: google.maps.places.PlaceResult) => void;
}) => {
    const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);

    const { env } = usePage<{ env: Env }>().props;
    const apiKey: string = env.googleApiKey;

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: apiKey, // Replace with your API key
        libraries,
    });

    if (!isLoaded) return <p>Loading...</p>;

    return (
        <Autocomplete
            onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
            onPlaceChanged={() => {
                const place: google.maps.places.PlaceResult|undefined = autocompleteRef.current?.getPlace();
                if (place && place.formatted_address) {
                    onSelect(place);
                }
            }}
        >
            <Input
                type="text"
                value={address}
                required
                autoComplete="new-password"
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Enter your address"
                className=""
            />
        </Autocomplete>
    );
};

export default AddressAutocomplete;
